import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Layout, Collapse, Typography, Row, Col } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { StoreContext } from '../store/index';

const { Content } = Layout;
const { Panel } = Collapse;
const { Title, Paragraph, Text } = Typography;

const News = () => {
  const store = useContext(StoreContext);
  const {
    user: [user],
  } = store;
  const navigate = useNavigate();
  const { formatMessage } = useIntl();

  return (
    <Layout style={{ padding: '8px' }}>
      <Content
        style={{
          backgroundColor: 'white',
          borderRadius: '5px',
        }}>
        <PageHeader
          className="site-page-header"
          onBack={user?.isOwner ? () => navigate('/') : null}
          title={
            <div
              style={{
                backgroundColor: 'white',
                padding: '10px 20px',
                borderRadius: '5px',
              }}>
              Game Booking
            </div>
          }
        />
        <Row justify="center">
          <Col span={24}>
            <Collapse
              style={{
                backgroundColor: 'white',
              }}
              defaultactivekey={['1']}>
              <Panel header="¿Qué es GameBooking?" key="1">
                <Paragraph
                  style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  }}>
                  <Text strong>GameBooking </Text>
                  es una plataforma diseñada para facilitar la organización de
                  tus partidos de fútbol. Con nosotros, puedes:
                </Paragraph>
                <ul>
                  <li>
                    <Text strong>Reservar Canchas: </Text>
                    Encuentra y reserva canchas de fútbol en tu área con solo
                    unos clics.
                  </li>
                  <li>
                    <Text strong>Invitar Amigos: </Text>
                    Crea partidos e invita a tus amigos a unirse directamente
                    desde la app.
                  </li>
                  <li>
                    <Text strong>Crear Equipos: </Text>
                    Forma equipos fácilmente y gestiona la lista de jugadores.
                  </li>
                  <li>
                    <Text strong>Organizar Torneos: </Text>
                    Lanza y gestiona torneos locales para añadir un poco de
                    competencia amistosa.
                  </li>
                  <li>
                    <Text strong>Recibir Notificaciones: </Text>
                    Mantente al tanto de tus partidos y torneos con
                    notificaciones en tiempo real.
                  </li>
                  <li>
                    <Text strong>Explorar Nuevas Canchas: </Text>
                    Descubre nuevas ubicaciones para jugar y lee reseñas de
                    otros jugadores.
                  </li>
                </ul>
              </Panel>
              <Panel header="Novedades y Actualizaciones" key="2">
                <Paragraph>
                  Aquí te mantendremos informado sobre todas las novedades y
                  actualizaciones de la aplicación:
                </Paragraph>
                <ul>
                  <li>
                    <Text strong>Nueva Función: </Text>
                    Hemos añadido una nueva función de chat para que puedas
                    coordinar con tu equipo directamente en la aplicación.
                  </li>
                  <li>
                    <Text strong>Actualización de Canchas: </Text>
                    Ahora puedes ver la disponibilidad de canchas en tiempo
                    real.
                  </li>
                  <li>
                    <Text strong>Eventos Especiales: </Text>
                    No te pierdas nuestros eventos y torneos especiales
                    organizados cada mes.
                  </li>
                </ul>
              </Panel>
              <Panel header="Únete a Nuestra Comunidad" key="4">
                <Paragraph>
                  Conéctate con otros apasionados del fútbol en nuestra
                  comunidad. Comparte tus experiencias, organiza partidos y haz
                  nuevos amigos.
                </Paragraph>
              </Panel>
            </Collapse>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default News;
